import { render, staticRenderFns } from "./MentionForm.vue?vue&type=template&id=3840ef7f&"
import script from "./MentionForm.vue?vue&type=script&lang=js&"
export * from "./MentionForm.vue?vue&type=script&lang=js&"
import style0 from "./MentionForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports